<!----------------------- Компонент для підтвердження країни --------------------->
<template>
    <smallModal @escape="$emit('close')">
        <div v-if="country" class="confirm-country">
            <span class="country-title">{{ countryName + " - " + lang['areYourCountry'] }}</span>
            <span class="country-text">{{ this.lang['CountryPhoneFormat'] }}</span>
        </div>
        <hr>
        <div class="buttons">
            <button class="btn btn-secondary" @click="$emit('n')">{{ lang['n'] }}</button>
            <button class="btn btn-success" @click="save">{{ lang['y'] }}</button>
        </div>
    </smallModal>
</template>

<script>
import smallModal from '../modals/smallModal'; // Компонент маленького модального вікна
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами

export default {
  props: ['country'],
  components: {
    smallModal
  },
  data() {
    return {
    }
  },
  mounted(){
    keyevent.$off('enter');
    keyevent.$on('enter', () => {
        this.save();
    });
  },
  methods: {
    save() {
       console.log("save");
       this.$emit("y")
    }
  },
  computed: {
    // Мова додатку
    lang() {
        return window.lang
    },
    countryName(){
      return this.country.englishname
    }
  }
}
</script>

<style scoped>
.country-title {
  font-weight: 600;
}
.btn {
  width: 49%;
}

.btn-success {
  background-color: #00c279;
  border: none;
}

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success:hover {
  background-color: #00B26F;
}

.btn-secondary {
  font-size: 10pt;
}

.confirm-country {
  text-align: center;
  display: flex;
  flex-flow: column;
  gap: 5px;
}

.country-text {
  max-width: 300px;
  margin: 0 auto;
  color: #8A8E91;
}

.buttons {
  display: flex;
  justify-content: space-between;
}
</style>